// extracted by mini-css-extract-plugin
module.exports = {"container":"HeadIcons_container__vFJw6","btn":"HeadIcons_btn__2wjHM"};